export const resourceKeys = Object.freeze({
  ACCESSIBILITY_STATEMENT: {
    RESOURCE_KEY: 'ACCESSIBILITY_STATEMENT_CONFIGURATION',
    EN: 'ACCESSIBILITY_STATEMENT_CONFIGURATION_EN',
    LT: 'ACCESSIBILITY_STATEMENT_CONFIGURATION_LT',
    EL: 'ACCESSIBILITY_STATEMENT_CONFIGURATION_EL',
    ES: 'ACCESSIBILITY_STATEMENT_CONFIGURATION_ES',
  },
  LANDING_PAGE: {
    RESOURCE_KEY: 'LANDING_PAGE_CONFIGURATION',
    EN: 'LANDING_PAGE_CONFIGURATION_EN',
    LT: 'LANDING_PAGE_CONFIGURATION_LT',
    EL: 'LANDING_PAGE_CONFIGURATION_EL',
    ES: 'LANDING_PAGE_CONFIGURATION_ES',
  },
});
